var exports = {
  "r": "dialog__sfbSqp",
  "D": "codeBlock__LsGHfB",
};

module.exports = exports;
